var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadgeDolyameForBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 20,
    viewBox: "0 0 68 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 20,
    rx: 4,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33871_1002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9392 6H14.6044V12.7689H15.9392V6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0711 6.37876H11.7363V13.1475H13.0711V6.37876Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.203 6.80162H8.86814V13.5716H10.203V6.80162Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33482 7.22917H6L6.00001 14H7.33482L7.33482 7.22917Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.194 9.60607L49.0447 7.21646H47.7882V12.7492H49.1001V9.21922L51.0623 11.3106H51.3047L53.2332 9.21922V12.7492H54.5451V7.21646H53.2886L51.194 9.60607Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.795 7.21646L57.5435 10.8126V7.21646H56.2316V12.7492H57.4335L60.685 9.15313V12.7492H61.9969V7.21646H60.795Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7222 9.24098C40.7222 10.1219 41.2039 10.8158 41.9433 11.1067L40.5568 12.7492H42.1625L43.4238 11.255H44.7886V12.7492H46.1005V7.21646H42.7606C41.5154 7.21646 40.7222 8.06834 40.7222 9.24098ZM44.7895 8.43504V10.0711H43.0039C42.4082 10.0711 42.0886 9.73905 42.0886 9.25226C42.0886 8.76548 42.4194 8.43343 43.0039 8.43343L44.7895 8.43504Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.626 8.32302C34.5457 10.2258 34.1443 11.4541 33.3583 11.4541H33.1616V12.7823L33.3712 12.7936C34.9472 12.8814 35.8183 11.4984 35.9612 8.47776H38.0341V12.7492H39.3436V7.21646H34.6702L34.626 8.32302Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6877 7.13916C27.9134 7.13916 26.6369 8.36741 26.6369 9.98251C26.6369 11.6532 28.0258 12.838 29.6877 12.838C31.4187 12.838 32.7635 11.5871 32.7635 9.98251C32.7635 8.37789 31.4187 7.13916 29.6877 7.13916ZM29.6877 11.5098C28.685 11.5098 28.0017 10.857 28.0017 9.98251C28.0017 9.08631 28.6858 8.45123 29.6877 8.45123C30.6897 8.45123 31.3962 9.11532 31.3962 9.98251C31.3962 10.8497 30.6801 11.5098 29.6877 11.5098Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2456 7.2269H20.6155L20.5713 8.33345C20.5055 9.9276 20.0896 11.4436 19.3036 11.4653L18.9399 11.4766V13.9998L20.263 13.9971V12.75H24.8594V13.9971H26.1937V11.4653H25.2456V7.2269ZM23.9337 11.4653H21.1341C21.6078 10.7464 21.8615 9.70597 21.9057 8.489H23.9337V11.4653Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33871_1002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 8,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeDolyameForBlack);
export default __webpack_public_path__ + "static/media/BadgeDolyame_forBlack.9fee97dc2c0e78e79f6f3b48a3327cf0.svg";
export { ForwardRef as ReactComponent };